import { render } from "./g-admin-cache.vue?vue&type=template&id=f1e405fe&ts=true"
import script from "./g-admin-cache.vue?vue&type=script&lang=tsx"
export * from "./g-admin-cache.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__